import 'babel-polyfill'
import Vue from 'vue'
// import axios from 'axios'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/lib-flexible/flexible.js'
import './plugins/element.js'
import qs from 'qs'
import Debounce from '@/util/utils'
import './assets/css/common.css'
import 'video.js/dist/video-js.css'
import VuePreview from 'vue-preview'
import animated from 'animate.css'
import cascaderMulti from "cascader-multi";
import 'swiper/dist/css/swiper.css';
import 'swiper/dist/js/swiper.min.js';
Vue.use(cascaderMulti);
Vue.use(animated)
// 兼容ie9
function reRequestAnimationFrame  () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] ||
          window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function (callback, element) {
          var currTime = new Date().getTime();
          var timeToCall = Math.max(0, 16 - (currTime - lastTime));
          var id = window.setTimeout(function () { callback(currTime + timeToCall); },
              timeToCall);
          lastTime = currTime + timeToCall;
          return id;
      };
  }

  if (!window.cancelAnimationFrame) {
      window.cancelAnimationFrame = function (id) {
          clearTimeout(id);
      };
  }
}

reRequestAnimationFrame();

Vue.use(VuePreview, {
  mainClass: 'pswp--minimal--dark',
  barsSize: {
    top: 0,
    bottom: 0
  },
  captionEl: true,
  fullscreenEl: true,
  shareEl: true,
  bgOpacity: 0.9,
  tapToClose: true,
  tapToToggleControls: false
})

Vue.component('Debounce',Debounce)
Vue.prototype.$qs = qs
// Vue.prototype.axios=axios

Vue.config.productionTip = false


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js